import styled from 'styled-components';

const Label = styled.div`
    background:#319795;
    width:100%;
    height:3rem;
    text-align:center;
    font-size:19px;
    display:flex;
    align-items:center;
    justify-content:center;
    color:white;
    border-radius:20px 20px 0 0;
`

export default Label;